import type { UserType } from 'src/app/core/feature-user/provider/userProvider';

/**
 * Value sent as `status` when a content is created or edited.
 *
 * Company users publish directly (status checked), so the content shows up
 * in "Contenidos Internos Compartidos". Expert content goes to review
 * (status unchecked). An unknown or not-yet-loaded account type also goes to
 * review: publishing by mistake is worse than an extra review.
 */
export const resolveContentStatus = (
  accountType: UserType | null | undefined
): 'true' | 'false' => (accountType === 'company' ? 'true' : 'false');
